/**
 * Header Functionality
 * Handles mobile drawer toggles, search visibility, and language selectors.
 */

document.addEventListener('DOMContentLoaded', () => {
    const selectors = {
        mobileToggle: '[data-mobile-toggle]',
        searchToggle: '[data-search-toggle]',
        drawer: '#mobileDrawer',
        overlay: '.mobile-drawer-overlay',
        searchBar: '#headerSearch',
        langSelect: '.mobile-drawer__lang-select',
        langDropdown: '.mobile-drawer__lang-dropdown',
    };

    const mobileToggleBtns = document.querySelectorAll(selectors.mobileToggle);
    const searchToggleBtns = document.querySelectorAll(selectors.searchToggle);
    const overlay = document.querySelector(selectors.overlay);
    const langSelect = document.querySelector(selectors.langSelect);
    const langDropdown = document.querySelector(selectors.langDropdown);

    // Mobile Drawer Toggle
    const toggleDrawer = () => {
        const drawer = document.querySelector(selectors.drawer);
        const overlay = document.querySelector(selectors.overlay);

        if (drawer && overlay) {
            const isActive = drawer.classList.contains('active');
            if (isActive) {
                drawer.classList.remove('active');
                overlay.classList.remove('active');
                document.body.style.overflow = '';
            } else {
                drawer.classList.add('active');
                overlay.classList.add('active');
                document.body.style.overflow = 'hidden';
            }
        }
    };

    mobileToggleBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            toggleDrawer();
        });
    });

    if (overlay) {
        overlay.addEventListener('click', toggleDrawer);
    }

    // Mobile Search Toggle
    const toggleSearch = () => {
        const searchBar = document.querySelector(selectors.searchBar);
        if (searchBar) {
            searchBar.classList.toggle('active');
            if (searchBar.classList.contains('active')) {
                const input = searchBar.querySelector('input');
                if (input) input.focus();
            }
        }
    };

    searchToggleBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            toggleSearch();
        });
    });

    // Language Dropdown
    if (langSelect && langDropdown) {
        langSelect.addEventListener('click', (e) => {
            e.preventDefault();
            langDropdown.classList.toggle('active');
        });

        document.addEventListener('click', (e) => {
            if (langDropdown.classList.contains('active') && !langDropdown.contains(e.target)) {
                langDropdown.classList.remove('active');
            }
        });
    }
});
